import script from "./AttendanceList.vue?vue&type=script&setup=true&lang=js"
export * from "./AttendanceList.vue?vue&type=script&setup=true&lang=js"

import "./AttendanceList.vue?vue&type=style&index=0&id=572d5010&lang=css"

const __exports__ = script;

export default __exports__